import { useState } from "react";
import { useLocation } from "react-router-dom";
import AssistenteChat, { useChatAI } from "./AssistenteChat";
import { Sparkle, X } from "@phosphor-icons/react";

const NASCOSTO = ["/impresa", "/dashboard", "/assistente", "/login", "/abbonamento"];

/** Bottone fluttuante + pannello laterale con l'assistente AI (impresa o studio in base alla pagina). Lo stato della chat resta tra apertura e chiusura. */
export default function AssistenteFloating() {
  const [aperto, setAperto] = useState(false);
  const { pathname } = useLocation();
  const impresa = pathname.startsWith("/impresa");
  const chatImpresa = useChatAI("impresa");
  const chatStudio = useChatAI("studio");
  if (NASCOSTO.includes(pathname)) return null;
  const ambito = impresa ? "impresa" : "studio";
  return (
    <>
      <button type="button" onClick={() => setAperto((v) => !v)} className={`fixed bottom-5 right-5 z-50 h-12 w-12 rounded-full shadow-lg flex items-center justify-center text-white transition-transform hover:scale-105 ${aperto ? "bg-slate-700" : "bg-[#0B1F3A]"}`} data-testid="assistente-float-btn" aria-label="Assistente AI" title="Assistente AI">
        {aperto ? <X size={20} /> : <Sparkle size={20} weight="fill" />}
      </button>
      <div className={`fixed top-0 right-0 z-40 h-full w-full sm:w-[420px] bg-white border-l border-slate-200 shadow-2xl transition-transform duration-300 ${aperto ? "translate-x-0" : "translate-x-full"}`} data-testid="assistente-float-panel" aria-hidden={!aperto}>
        <div className="h-full p-4 pb-20 flex flex-col">
          {aperto && <AssistenteChat ambito={ambito} chat={impresa ? chatImpresa : chatStudio} flat onNaviga={() => setAperto(false)} />}
        </div>
      </div>
    </>
  );
}
